<p>te-role-func works!</p>
